import React from 'react';
import { ReactComponent as HistorySVG } from '../assets/svg/history_diagram.svg';
import { ReactComponent as Pdf } from '../assets/svg/pdf.svg';
import ContentBuilder from '../core/ContentBuilder';
import Page from '../core/screens/Page';
import '../css/screens/AboutPage.scss';
import Grid from '../responsive/Grid';
import * as Logos from '../ui/Logos';
import ResponsiveImage from '../ui/ResponsiveImage';
import { MissionLogo } from '../ui/Vectors';




export default class AboutPage extends Page {

	build_project(data)
	{
		return (
			<section className='project'>
				<div className='header'>
					<div className="title">{data.title}</div>
					<div className="subtitle">{data.subtitle}</div>
				</div>
				<Grid cols={2} skip={1} className='padding' breakpoints={{small: {cols: 4, skip: 0}}}>
					<div className="text">{data.text1}</div>
				</Grid>
				<Grid cols={4} skip={0} className="text-center">
					<ResponsiveImage data={data.image1} className='image'></ResponsiveImage>
					{/* <img className='image hide-small' src={data.image1.src} width={data.image1.width} height={data.image1.height} /> */}
				</Grid>
				<Grid cols={2} skip={1} className='padding' breakpoints={{small: {cols: 4, skip: 0}}}>
					<div className="text">{data.text2}</div>
				</Grid>
				{
					(data.pdf)?
					(
						<Grid cols={2} skip={1} className='padding' breakpoints={{small: {cols: 4, skip: 0}}}>
							<a className="pdfLink" href={data.pdf.url} target="_blank">▼ <span className="underline">{data.pdf.label}</span> <Pdf></Pdf></a>
						</Grid>

					):null
				}
			</section>
		)
	}

	build_naming(data)
	{
		return (
			<section className='naming'>
				<div className='header'>
					<div className="title">{data.title}</div>
					<div className="subtitle">{data.subtitle}</div>
				</div>
				<Grid cols={1} className='text-center logo' breakpoints={{small: {cols: 4, skip: 0}}}>
					<MissionLogo></MissionLogo>
				</Grid>
				<Grid cols={2} breakpoints={{small: {cols: 4, skip: 0}}}>
					{ContentBuilder.build(data.content)}
				</Grid>
			</section>
		)
	}

	build_history(data)
	{
		return (
			<section className='history'>
				<div className='header'>
					<div className="title">{data.title}</div>
					<div className="subtitle">{data.subtitle}</div>
				</div>
				<Grid cols={4} className="text-center">
					<HistorySVG></HistorySVG>
				</Grid>
			</section>
		)
	}

	build_partners(data)
	{
		return (
			<section className='partners'>
				<div className='header'>
					<Grid cols={2} breakpoints={{small: {cols: 4, skip: 0}}}>
						<div className='title'>{data.title}</div>
					</Grid>
					<Grid cols={2} breakpoints={{small: {cols: 4, skip: 0}}}>
						<div className="text description padding">{data.description}</div>
					</Grid>
				</div>
				<Grid cols={1} className="padding">
					<LogoLink data={data['mlit-logo']}></LogoLink>
				</Grid>
				<div>
					{
						data.logos.map((e, i)=>{
							return (
								<Grid cols={1} key={i} breakpoints={{small: {cols: 2, skip: 0}}} className="padding"><LogoLink data={e}></LogoLink></Grid>
							)
						})
					}
				</div>
				{
					(data.credits)?(
						<Grid cols={4} className="credits padding">
							<div className="credits-title">{data.credits.title}</div>
							<div className="credits-text">{data.credits.text}</div>
						</Grid>

					):null
				}
			</section>
		)
	}

	build_credits(data)
	{

	}

	render() {
		return this.wrap(
			<React.Fragment>
				{(this.props.content.project)?this.build_project(this.props.content.project):null}
				{(this.props.content.naming)?this.build_naming(this.props.content.naming):null}
				{(this.props.content.history)?this.build_history(this.props.content.history):null}
				{(this.props.content.partners)?this.build_partners(this.props.content.partners):null}
				{(this.props.content.credits)?this.build_credits(this.props.content.credits):null}
			</React.Fragment>
		);
	}
}

type LogoLinkProps = {
	data: {
		logo:string,
		href:string,
	}
}
class LogoLink extends React.Component<LogoLinkProps>
{
	render()
	{
		let Logo = Logos[this.props.data.logo];
		return (
			<a href={this.props.data.href} target='_blank'><div className="logoItem"><Logo></Logo></div></a>
		)
	}
}